import styled from 'styled-components';

export const SPremiumDiv = styled.div`
    background-color: ${({ theme }) => theme.color.premium.main};
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SPremiumDivActivated = styled(SPremiumDiv)`
    background-color: ${({ theme }) => theme.color.premium.activated};
`;
